import { render } from "./DialogFont.vue?vue&type=template&id=765f0cb6&scoped=true"
import script from "./DialogFont.vue?vue&type=script&lang=js"
export * from "./DialogFont.vue?vue&type=script&lang=js"

import "./DialogFont.vue?vue&type=style&index=0&id=765f0cb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765f0cb6"]])

export default __exports__